import { firebaseImport } from "../../config/main_config";
import { findFrameworkName } from "./findFrameworkName.util";
import { sanitise } from "./sanitise.util";
/**
 * Interface representing a single document's data structure.
 */
// interface DocumentData {
//     fileName: string;
//     procRef?: string[];
//     [key: string]: any;
//     // Add other properties as needed
// }


/**
 * Generates an HTML list of uploaded documents with corresponding framework badges based on provided mappings.
 * @param matchingDocs - An array of document objects to be parsed into HTML.
 * @returns A promise that resolves to an HTML string representing the list of documents.
 */
export async function parseDocsMSG(matchingDocs: firebaseImport.firestore.DocumentData[]): Promise<string> {
    // Define a map that associates procRefs to frameworks
    const frameworkMap: { [key: string]: string } = {
        // 'ISM-1488': 'ISO 27001',
        // 'ISM-9001': 'ISO 9001',
        // 'ISM-27701': 'ISO 27701',
        // 'ISM-14001': 'ISO 14001',
        // Add more mappings as needed
    };

    // Initialize the file list as an HTML string
    let fileListHTML = '<ul class="file-list">';

    // Iterate over the matching documents
    if (matchingDocs && matchingDocs.length > 0) {
        for (const doc of matchingDocs) {
            fileListHTML += `
            <li class="file-item">
            <a class="edit-link" onclick="(async () => { await new SupportingDocs.Modal().open('edit', ${doc.docID}, true); } )();">
                <i class="fa-duotone fa-solid fa-pencil"></i>
            </a>
            <span class="file-name">${sanitise(doc.fileName)}</span>
            <div class="badges">`;

            // Iterate over the procRefs and add the corresponding framework badges
            if (doc.procRef && doc.procRef.length > 0) {
                console.log('Processing procRefs:', doc.procRef);
                for (let procID of doc.procRef) {
                    let frameworkName = await findFrameworkName(procID);
                    const framework = frameworkName !== undefined ? frameworkName : procID; // Default to procID if not found
                    console.log('Framework:', framework);
                    if (!frameworkMap[framework]) {
                        frameworkMap[framework] = framework; // Add new framework to map if not already present
                    }

                    fileListHTML += `<span class="badge">${framework}</span>`;
                }
            }

            // Close the badges and file-item divs
            fileListHTML += `
            </div>
        </li>`;
        }
    } else {
        fileListHTML += `<li class="file-item">
            <a class="edit-link" style="visibility: hidden;">
                <i class="fa-duotone fa-solid fa-pencil"></i>
            </a>
            <span class="file-name">No matching documents found</span>.</li>`;
    }

    // Add the upload new file list item
    fileListHTML += `
        <li class="file-item">
            <a class="upload-link" id="uploadFileButton" onclick="(async () => { await new SupportingDocs.Modal().open('new'); } )();">
                <i class="fa-duotone fa-upload"></i> Upload File
            </a>
        </li>
    `;

    // Close the ul tag
    fileListHTML += '</ul>';

    return fileListHTML;
}